const OrderLayout = () => import(/* webpackChunkName: "order" */'@/components/orders/OrderLayout')
const OrderList = () => import(/* webpackChunkName: "order" */'@/components/orders/OrderList')
const OrderRecList = () => import(/* webpackChunkName: "order" */'@/components/orders/OrderRecList')
const OrderDetail = () => import(/* webpackChunkName: "order" */'@/components/orders/OrderDetail')
const WriteInOrder = () => import(/* webpackChunkName: "order" */'@/components/orders/WriteInOrder')
const WriteInOrderDetail = () => import(/* webpackChunkName: "order" */'@/components/orders/WriteInOrderDetail')

export default {
  // name: 'order',
  path: 'order',
  component: OrderLayout,
  children: [
    {
      name: 'orderList',
      path: 'orderList',
      component: OrderList,
      meta: {
        module: 'order',
        keepAlive: true,
        isOutside: false, // 是不是从tab切换进入
      },
    },
    {
      name: 'OrderRecList',
      path: 'OrderRecList',
      component: OrderRecList,
      meta: {
        module: 'order',
      },
    },
    {
      name: 'WriteInOrder',
      path: 'OrderRecList/WriteInOrder',
      component: WriteInOrder,
      meta: {
        module: 'order',
      },
    },
    {
      name: 'WriteInOrderDetail',
      path: 'OrderRecList/WriteInOrderDetail',
      component: WriteInOrderDetail,
      meta: {
        module: 'order',
      },
    },
    {
      name: 'WriteInOrderDetailC',
      path: 'orderList/WriteInOrderDetail',
      component: WriteInOrderDetail,
      meta: {
        module: 'order',
      },
    },
    {
      name: 'orderDetail',
      path: 'orderList/detail/:id',
      component: OrderDetail,
      meta: {
        module: 'order',
        isSlibing: true,
      },
    },
    {
      path: '/',
      redirect: {name: 'orderList'},
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/order.js